/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Created_ColInputs */

const en_settings_apikeys_created_col = /** @type {(inputs: Settings_Apikeys_Created_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

const zh_settings_apikeys_created_col = /** @type {(inputs: Settings_Apikeys_Created_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建时间`)
};

/**
* | output |
* | --- |
* | "Created" |
*
* @param {Settings_Apikeys_Created_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_created_col = /** @type {((inputs?: Settings_Apikeys_Created_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Created_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_created_col(inputs)
	return zh_settings_apikeys_created_col(inputs)
});
export { settings_apikeys_created_col as "settings.apikeys.created_col" }